import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthUser } from "../hooks/useAuthUser";

/**
 * Layout-route guard — SPEC-20260505-1712 (cookie BFF).
 *
 * Substitui leitura de sessionStorage do mock por `useAuthUser` (que chama
 * `/api/auth/me`). Mostra "Verificando…" enquanto carrega; redireciona pra
 * `/login?returnTo=<path>` se não autenticado.
 */
export function RequireAuth() {
  const location = useLocation();
  const { user, loading } = useAuthUser();

  if (loading) {
    // Estado breve enquanto fetchCurrentUser resolve. Evita flicker do redirect.
    return (
      <div className="min-h-screen bg-background grid place-items-center text-xs text-muted-foreground">
        Verificando sessão…
      </div>
    );
  }

  if (!user) {
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  return <Outlet />;
}
